import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LINK_OF_ALL_PAGES } from "const/common";
import Image from "next/image";
import Container from "../common/Container";
import PrimaryButton from "../common/PrimaryButton";

const OurRecentWork = (properties) => {
  const { title, link, testimonialData, image } = properties.portfolioSection;
  return (
    <Container large className="pt-8 pb-16 md:pt-24 md:pb-28">
      <div className="flex justify-between pb-14 lg:pb-20">
        <h2 className="w-4/5 md:full text-4xl md:text-3xl lg:text-6xl font-medium">
          <span>Check our recent work</span>
        </h2>
        <div className="hidden md:block">
          <PrimaryButton
            link={LINK_OF_ALL_PAGES.mainPages.portfolio}
            val="View All Project"
          />
        </div>
      </div>
      <div className="flex flex-col lg:flex-row justify-between">
        <div className="lg:w-1/2">
          <div>
            <Image
              alt={image.altText}
              height={1000}
              src={image.path}
              title={image.altText}
              width={1000}
            />
          </div>
        </div>
        <div className="pt-10 md:py-12 lg:pr-0 lg:pl-20 lg:pt-0 lg:w-1/2">
          <h3 className="text-3xl md:text-2xl lg:text-4xl font-normal lg:leading-snug">
            <span>{title}</span>
          </h3>
          <div className="pt-4 pb-8 lg:pt-8 lg:pb-20 text-base lg:text-xl font-medium">
            <a className="text-primary-yellow flex items-center" href={link}>
              <span>View More</span>
              <span>
                <FontAwesomeIcon
                  height={20}
                  icon={faArrowRightLong}
                  width={40}
                />
              </span>
            </a>
          </div>
          <div>
            <span className="text-5xl lg:text-7xl font-medium text-black">
              “
            </span>
            <p className="-mt-4 mb-8 text-base lg:text-2xl leading-normal text-black">
              <span>{testimonialData.description}</span>
            </p>
            <span className="text-lg lg:text-2xl text-black">
              {testimonialData.clientName}
            </span>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default OurRecentWork;
